<img id="logo" ngSrc="assets/img/ogi-logo.png" width="200" height="51" alt="OGI Logo" priority />
<div id="page">
  @if (!displayMaintenancePage()) {
    <div class="container">
      <h4>Login</h4>
      <div aria-live="assertive">
        @if (loginError()?.message) {
          <div class="error" role="alert"><span>Error: </span>{{ loginError()?.message }}</div>
        }
      </div>
      <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
        <app-mat-form-field
          iconName="email"
          [field]="emailField"
          [parentForm]="loginForm"
        >
        </app-mat-form-field>
        <div>
          <app-mat-form-field
            iconName="lock"
            [field]="passwordField"
            [parentForm]="loginForm"
          ></app-mat-form-field>
          <div class="options__container">
            <div class="checkbox__container">
              <app-checkbox
                [checkbox]="rememberMe"
                [parentForm]="loginForm"
              ></app-checkbox>
              <div class="tooltip" role="tooltip">
                <mat-icon>info</mat-icon>
                <div class="top">
                {{ tooltipText() }}
                <i></i>
              </div>
              <div class="tooltip-accessibility">{{ tooltipText() }}</div>
            </div>
          </div>
            <a [routerLink]="'/forgot-password'">Forgot password?</a>
          </div>
        </div>
        <app-button
          buttonType="submit"
          buttonStyle="standard"
          label="Login"
          buttonId="login"
          [isDisabled]="loginForm.invalid"
          [isProcessing]="isProcessing()"
        >
        </app-button>
      </form>
    </div>
  } @else {
    <div class="container maintenance">
      <div id="maintenance-icon">
        <mat-icon>construction</mat-icon>
      </div>
      <h4 class="maintenance-title">Down for Maintenance</h4>
      <p class="body1">Our website is currently undergoing scheduled maintenance.  We should be back shortly.  Thank you for your patience.</p>
      <p class="body1">If you have any further questions, please contact <a href="mailto:help@ogibiotec.com">help@ogibiotec.com</a></p>
    </div>
  }
</div>
